export default {
    modules: {
        chat: true,
        inbox: true,
        medical: true,
        symptom: true,
        healthtips: true,
        profile: true,
        documents: false,
        emergency: true
    },
    practitioner: {
        type: 'nurse',
        plural_type: 'nurses'
    },
    app: {
        name: 'Medi4U',
        endpoint: 'https://medi4u.co.za/'
    },
    registration: {
        simple: false
    },
    permissions: [
        'android.permission.RECORD_AUDIO',
        'android.permission.WRITE_EXTERNAL_STORAGE',
        'android.permission.CALL_PHONE',
        'android.permission.CAMERA',
        'android.permission.ACCESS_FINE_LOCATION'
    ],
    requiresLocation: true
}